export const defaultInvoiceSettings = {
  legalName: '',
  tradingName: '',
  invoiceAddress: '',
  invoiceEmail: '',
  telephone: '',
  companyRegistrationNumber: '',
  vatRegistrationNumber: '',
  invoicePrefix: 'INV',
  nextInvoiceNumber: 1,
  paymentTermsDays: 14,
  bankAccountName: '',
  bankName: '',
  sortCode: '',
  accountNumber: '',
  paymentReferenceInstructions: '',
  defaultVatRate: 20,
  invoiceFooterNote: '',
};

function toSafeString(value, fallback = '') {
  if (value === null || value === undefined) {
    return fallback;
  }

  return String(value);
}

function toSafeNumber(value, fallback, min = 0) {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return fallback;
  }

  return Math.max(min, numericValue);
}

export function normalizeInvoiceSettings(raw = {}) {
  return {
    legalName: toSafeString(raw.legalName, '').trim(),
    tradingName: toSafeString(raw.tradingName, '').trim(),
    invoiceAddress: toSafeString(raw.invoiceAddress, '').trim(),
    invoiceEmail: toSafeString(raw.invoiceEmail, '').trim(),
    telephone: toSafeString(raw.telephone, '').trim(),
    companyRegistrationNumber: toSafeString(raw.companyRegistrationNumber, '').trim(),
    vatRegistrationNumber: toSafeString(raw.vatRegistrationNumber, '').trim(),
    invoicePrefix: toSafeString(raw.invoicePrefix, defaultInvoiceSettings.invoicePrefix).trim() || defaultInvoiceSettings.invoicePrefix,
    nextInvoiceNumber: Math.round(toSafeNumber(raw.nextInvoiceNumber, defaultInvoiceSettings.nextInvoiceNumber, 1)),
    paymentTermsDays: Math.round(toSafeNumber(raw.paymentTermsDays, defaultInvoiceSettings.paymentTermsDays, 0)),
    bankAccountName: toSafeString(raw.bankAccountName, '').trim(),
    bankName: toSafeString(raw.bankName, '').trim(),
    sortCode: toSafeString(raw.sortCode, '').trim(),
    accountNumber: toSafeString(raw.accountNumber, '').trim(),
    paymentReferenceInstructions: toSafeString(raw.paymentReferenceInstructions, '').trim(),
    defaultVatRate: Number(toSafeNumber(raw.defaultVatRate, defaultInvoiceSettings.defaultVatRate, 0).toFixed(2)),
    invoiceFooterNote: toSafeString(raw.invoiceFooterNote, '').trim(),
  };
}
